import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Modal, FormGroup, Alert } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import CargomaticInput from 'components/v2/input';
import { isEmpty } from 'lodash';
import LoadingCircle from 'components/ui/LoadingCircle';
const hasOwnProperty = Object.prototype.hasOwnProperty;
class AddDriverModal extends Component {
    constructor(props) {
        super(props);
        this.onSave = () => {
            this.setState({ saving: true }, () => this.props.onSave(this.getFields()));
        };
        this.state = {
            first_name: '',
            last_name: '',
            username: '',
            email: '',
            password: '',
            cdl_number: '',
            confirmation: '',
            receive_offers: false,
            errors: {
                first_name: {},
                last_name: {},
                phone: {},
                password: {},
                cdl: {},
                confirmation: {},
                email: {},
            },
        };
    }
    onChange(key, value) {
        this.setState({ [key]: value });
    }
    onCheckboxChange(key, checked) {
        this.setState({ [key]: checked });
    }
    getFields() {
        return Object.assign({}, this.state);
    }
    renderSuccessMessage() {
        const { t } = this.props;
        if (this.props.formState.isSuccess) {
            return (React.createElement(Alert, { bsStyle: "success" },
                React.createElement("p", null, t('DRIVER_ADDED_SUCCESS'))));
        }
        return null;
    }
    renderErrorMessage() {
        const { t } = this.props;
        if (!isEmpty(this.props.formState.error) &&
            this.props.formState.error.status) {
            const { formState: { error: { status }, }, } = this.props;
            return (React.createElement(Alert, { bsStyle: "danger" },
                React.createElement("p", null, t(status))));
        }
    }
    renderError(field) {
        const { t } = this.props;
        const { formState: { error }, } = this.props;
        if (!error || !error[field]) {
            return {};
        }
        return new Error(t(error[field]));
    }
    render() {
        const { errors } = this.state;
        const { t } = this.props;
        return (React.createElement(Modal, { show: this.props.formState.show, onHide: this.props.onHide, enforceFocus: false },
            React.createElement(Modal.Header, null,
                React.createElement("h3", { className: "text-grey-darkest" }, t('ADD_A_DRIVER'))),
            React.createElement(Modal.Body, null,
                this.renderSuccessMessage(),
                this.renderErrorMessage(),
                React.createElement(Row, null,
                    React.createElement(Col, { md: 6 },
                        React.createElement("div", { className: "space-y-8" },
                            React.createElement(CargomaticInput, { info: t('DRIVERS_FIRST_NAME'), error: this.renderError('first_name'), label: t('FIRST_NAME'), onChange: (value) => this.onChange('first_name', value), placeholder: t('FIRST_NAME'), type: "text", value: this.state.first_name }),
                            React.createElement(CargomaticInput, { info: t('DRIVERS_LAST_NAME'), error: this.renderError('last_name'), label: t('LAST_NAME'), onChange: (value) => this.onChange('last_name', value), placeholder: t('LAST_NAME'), type: "text", value: this.state.last_name }),
                            React.createElement(CargomaticInput, { info: t('DRIVERS_CDL_NUMBER'), error: this.renderError('cdl_number'), label: t('COMMERCIAL_DRIVER_LICENSE'), placeholder: t('COMMERCIAL_DRIVER_LICENSE'), onChange: (value) => this.onChange('cdl_number', value), type: "text", value: this.state.cdl_number }),
                            React.createElement(CargomaticInput, { info: t('DRIVERS_EMAIL_ADDRESS'), error: this.renderError('email'), label: t('EMAIL_ADDRESS'), onChange: (value) => this.onChange('email', value), placeholder: t('EMAIL'), type: "text", value: this.state.email }))),
                    React.createElement(Col, { md: 6 },
                        React.createElement("div", { className: "space-y-8" },
                            React.createElement(CargomaticInput, { info: t('DRIVERS_USERNAME_LOGIN_MOBILE_APP'), error: this.renderError('username'), label: t('USER_NAME'), onChange: (value) => this.onChange('username', value), placeholder: t('USER_NAME'), type: "text", value: this.state.username }),
                            React.createElement(CargomaticInput, { info: t('DRIVERS_PHONE_NUMBER'), label: t('PHONE_NUMBER'), error: this.renderError('phone'), onChange: (value) => this.onChange('phone', value), placeholder: t('PHONE_NUMBER'), type: "text", value: this.state.phone }),
                            React.createElement(CargomaticInput, { info: t('DRIVERS_PWD_LOGIN_MOBILE_APP'), label: t('PASSWORD'), error: this.renderError('password'), onChange: (value) => this.onChange('password', value), placeholder: t('PASSWORD'), type: "password", value: this.state.password }),
                            React.createElement(CargomaticInput, { info: t('DRIVERS_PWD_LOGIN_MOBILE_APP'), label: t('CONFIRM_PASSWORD'), onChange: (value) => this.onChange('confirmation', value), placeholder: t('CONFIRM_PASSWORD'), type: "password", error: this.renderError('password'), value: this.state.confirmation }),
                            React.createElement(CargomaticInput, { info: t('AUTO_SEND_DRIVERS_OFFERS_TO_MARKET'), label: t('RECEIVE_OFFERS'), onChange: (checked) => this.onCheckboxChange('receive_offers', checked), type: "checkbox", value: this.state.receive_offers }))))),
            React.createElement(Modal.Footer, null,
                React.createElement("button", { className: "button button-secondary", onClick: () => this.props.onHide() }, titleize(t('CLOSE'))),
                React.createElement("button", { disabled: this.props.savingDriver, className: "button button-green", onClick: this.onSave },
                    !this.props.savingDriver && t('ADD_DRIVER'),
                    this.props.savingDriver && (React.createElement(LoadingCircle, { text: `${t('SAVING')}...` }))))));
    }
}
AddDriverModal.propTypes = {
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    formState: PropTypes.shape({
        show: PropTypes.bool.isRequired,
        error: PropTypes.object.isRequired,
        isSuccess: PropTypes.bool.isRequired,
        savingDriver: PropTypes.bool.isRequired,
    }),
};
AddDriverModal.defaultProps = {
    formState: {
        show: false,
        error: {},
        success: false,
    },
};
export default withTranslation()(AddDriverModal);
